import {Cookies} from 'react-cookie';

import {AVATAR_COOKIE_ID, EMPION_COOKIE_ID} from '../../lib/constants';
import {User} from '../../types/User';

const COOKIES = new Cookies();
// TODO refactor this logic into a hook.
export default class CookieService {
  static getUserCookie(): User | null {
    const userCookie = COOKIES.get(EMPION_COOKIE_ID);
    return userCookie ? userCookie : null;
  }

  static getApplicantId(): string | null {
    const userCookie = CookieService.getUserCookie();
    return userCookie ? userCookie.id : null;
  }

  static setCookie(data: any): void {
    COOKIES.set(EMPION_COOKIE_ID, data, {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      httpOnly: false,
    });
  }

  static clearCookie(): void {
    COOKIES.remove(EMPION_COOKIE_ID, {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      httpOnly: false,
    });

    COOKIES.remove(AVATAR_COOKIE_ID, {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      httpOnly: false,
    });
  }
}
